export const SET_LIST = 'SET_LIST'



// WEBPACK FOOTER //
// ./src/features/Periodo/store/mutation-types.js